(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7516],{

/***/ 87290:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/ratio-calculator",
      function () {
        return __webpack_require__(21529);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ratio_calculator; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../packages/helper/src/JsonDebug.helper.tsx

const JsonDebugger = (param)=>{
    let { value  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
        children: JSON.stringify(value, null, 2)
    });
};

;// CONCATENATED MODULE: ../../packages/helper/src/index.ts





// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/seo/src/index.ts + 2 modules
var src = __webpack_require__(4033);
// EXTERNAL MODULE: ../../packages/ui/src/index.ts + 60 modules
var ui_src = __webpack_require__(34937);
// EXTERNAL MODULE: ./src/lib/modules/RatioCalculator/RatioCalculator.module.scss
var RatioCalculator_module = __webpack_require__(92063);
var RatioCalculator_module_default = /*#__PURE__*/__webpack_require__.n(RatioCalculator_module);
;// CONCATENATED MODULE: ./src/lib/modules/RatioCalculator/RatioCalculator.tsx






const RatioCalculator = ()=>{
    const previewBoxRef = (0,react.useRef)(null);
    const [displayValues, setDisplayValues] = (0,react.useState)([]);
    const [lockMode, setLockMode] = (0,react.useState)(false);
    const [ratioValues, setRatioValues] = (0,react.useState)({
        x: {
            pixels: 1600,
            ratio: 16
        },
        y: {
            pixels: 900,
            ratio: 9
        }
    });
    const gcd = (a, b)=>{
        if (!b) {
            return a;
        }
        return gcd(b, a % b);
    };
    const changeInputValues = (event, direction, valueType)=>{
        let _ratioValues = JSON.parse(JSON.stringify(ratioValues));
        let inputValue = parseFloat(event.target.value);
        const validChange = !isNaN(inputValue);
        if (!validChange) {
            inputValue = event.target.value;
        }
        _ratioValues[direction][valueType] = inputValue;
        if (valueType === "pixels" && validChange) {
            _ratioValues.x.ratio = _ratioValues.x.pixels / gcd(_ratioValues.x.pixels, _ratioValues.y.pixels);
            _ratioValues.y.ratio = _ratioValues.y.pixels / gcd(_ratioValues.x.pixels, _ratioValues.y.pixels);
        }
        if (valueType === "ratio" && validChange) {
            const pixelsY = _ratioValues.y.pixels;
            const pixelsX = _ratioValues.x.pixels;
            _ratioValues.x.pixels = pixelsX * (_ratioValues.x.ratio / _ratioValues.y.ratio);
            _ratioValues.y.pixels = pixelsY * (_ratioValues.x.ratio / _ratioValues.y.ratio);
        }
        setRatioValues(_ratioValues);
    };
    (0,react.useEffect)(()=>{
        const setDisplayWidths = ()=>{
            const containerHeight = previewBoxRef.current.clientHeight;
            const containerWidth = previewBoxRef.current.clientWidth;
            const displayValueX = ratioValues.x.ratio >= ratioValues.y.ratio ? containerWidth : containerHeight * (ratioValues.x.ratio / ratioValues.y.ratio);
            const displayValueY = ratioValues.y.ratio >= ratioValues.x.ratio ? containerHeight : containerHeight * (ratioValues.y.ratio / ratioValues.x.ratio);
            setDisplayValues([
                displayValueX,
                displayValueY
            ]);
        };
        window.addEventListener("resize", setDisplayWidths);
        setDisplayWidths();
        // clean up function
        return ()=>{
            // remove resize listener
            window.removeEventListener("resize", setDisplayWidths);
        };
    }, [
        ratioValues
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DynamicSeo */.K, {
                title: "Ratio calculator",
                description: "Awesome tool for ratios"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Section */.$0, {
                horizontalAlignment: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (RatioCalculator_module_default()).previewBox,
                        ref: previewBoxRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (RatioCalculator_module_default()).inner,
                            style: {
                                width: displayValues[0] + "px",
                                height: displayValues[1] + "px",
                                aspectRatio: ratioValues.x.ratio + " / " + ratioValues.y.ratio,
                                background: "red"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Input */.II, {
                        type: "text",
                        name: "ratio-value-x-pixels",
                        value: ratioValues.x.pixels,
                        onChange: (e)=>changeInputValues(e, "x", "pixels")
                    }),
                    "X",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Input */.II, {
                        type: "text",
                        name: "ratio-value-y-pixels",
                        value: ratioValues.y.pixels,
                        onChange: (e)=>changeInputValues(e, "y", "pixels")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Input */.II, {
                        type: "text",
                        name: "ratio-value-x-ratio",
                        value: ratioValues.x.ratio,
                        onChange: (e)=>changeInputValues(e, "x", "ratio")
                    }),
                    ":",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Input */.II, {
                        type: "text",
                        name: "ratio-value-y-ratio",
                        value: ratioValues.y.ratio,
                        onChange: (e)=>changeInputValues(e, "y", "ratio")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JsonDebugger, {
                value: ratioValues
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/lib/modules/RatioCalculator/index.ts


;// CONCATENATED MODULE: ./src/pages/tools/ratio-calculator.tsx

/* harmony default export */ var ratio_calculator = (RatioCalculator);


/***/ }),

/***/ 92063:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"RatioCalculator_container__ivKhL","previewContainer":"RatioCalculator_previewContainer__a9sSb","previewBox":"RatioCalculator_previewBox__ev2OV","inner":"RatioCalculator_inner__NM3YG"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(87290); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);